import { render, staticRenderFns } from "./DepartmentGroupListSelector.vue?vue&type=template&id=35e0c3da&scoped=true&"
import script from "./DepartmentGroupListSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentGroupListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentGroupListSelector.vue?vue&type=style&index=0&id=35e0c3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0c3da",
  null
  
)

export default component.exports